// extracted by mini-css-extract-plugin
module.exports = {"aforismi":"aforismi-module--aforismi--QAFz7","foto":"aforismi-module--foto--1kGy8"};